import React, { FC } from "react"
import { AIModelUsageListItem } from "./AIModelUsageListItem"
import { Map } from "immutable"
import {
    AIModelForApp,
    AIModelAssignmentEnum
} from "../../../../../../../../Models/API/AIModel"
import { metaAI } from "neql"

interface AIModelUsageListProps {
    model: AIModelForApp
    processingAssignments?: Map<AIModelAssignmentEnum, true>
    onChangeActiveness?: (
        assigned: AIModelAssignmentEnum,
        active: boolean,
        useLatestAi: boolean
    ) => void
}

export const AIModelUsageList: FC<AIModelUsageListProps> = ({
    model,
    processingAssignments,
    onChangeActiveness
}) => {
    return (
        <ul>
            {model.apps.map(app => (
                <AIModelUsageListItem
                    isModelOnline={
                        model.deployment?.status ===
                        metaAI.Meta_Ai_Deployment_Status_Enum.Online
                    }
                    key={app.assigned}
                    assignment={app}
                    isProcessing={
                        processingAssignments?.has(app.assigned) ?? false
                    }
                    onChangeActiveness={onChangeActiveness}
                />
            ))}
        </ul>
    )
}
